export default "__VITE_ASSET__6862da36__"